/** Ключи запросов калькулятора. Одно место, чтобы инвалидация не разъезжалась. */
export const CALCULATOR_KEYS = {
  metadata: ['calculator', 'metadata'] as const,
  dictionary: ['calculator', 'dictionary'] as const,
  cards: ['calculator', 'cards'] as const,
  saved: ['calculator', 'saved'] as const,
  labourRates: ['calculator', 'labour-rates'] as const,
  recipeLabour: (cardId: number) => ['calculator', 'labour', cardId] as const,
  recipes: (cardIds: readonly number[]) =>
    [
      'calculator',
      'recipes',
      [...cardIds].sort((a, b) => a - b).join(','),
    ] as const,
  basket: ['calculator', 'basket'] as const,
}

/**
 * Раздел целиком платный: 403 значит «нет подписки или авторизации».
 * Повторять такой запрос бессмысленно, показываем экран подписки.
 */
export const isPaywallStatus = (status: number | undefined): boolean =>
  status === 403
